/* eslint-disable no-restricted-syntax */
// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { ARYABHATTA_API_DOMAIN_V1, DOCS_API_DOMAIN, FLIGHT_PUSH_BOOKING } from 'config';
import { returnFiltersQueryString } from 'helpers/objectFunctions';
import { dispatch } from 'store';
import axios from 'utils/axios';
import { BOOKING_TYPE, CATEGORY_ACCOMODATION, CATEGORY_FLIGHTS, CATEGORY_PACKAGES } from 'views/pages/booking-requests/constant';
import { BOOKINGS, DEFAULT_ERROR_MESSAGE, HOLIDAY, HOLIDAYS_SYSYTEM } from '../constant';
import { openSnackbar } from './snackbar';
import { checkIsValidArray } from 'helpers/arrayFunctions';
import { fetchTransferModes } from 'utils/apis/booking-details';

// ----------------------------------------------------------------------
// Utility Functions START
const getOnTripSatisFactionRatingFromScore = (bookingData = {}) => {
    const onTripScore = bookingData?.trip_score;
    if (onTripScore === null) return 0;
    if (Number.isNaN(Number(onTripScore?.total_score))) return 0;
    const OnTripScoreNumberValue = Number(onTripScore?.total_score);
    switch (true) {
        case OnTripScoreNumberValue >= 90:
            return 5;
        case OnTripScoreNumberValue >= 80:
            return 4;
        case OnTripScoreNumberValue >= 70:
            return 3;
        case OnTripScoreNumberValue >= 60:
            return 2;

        default:
            return 1;
    }
};

// Utility Functions END

// ----------------------------------------------------------------------
const initialState = {
    error: null,
    data: {},
    bookingData: {},
    dayWiseData: {},
    utilities: {},
    isLoading: false,
    filters: {},
    serviceRequest: {},
    selectedBookingRequest: {},
    documentVoucher: '',
    documentVoucherId: null,
    financialData: {},
    autoSuggestData: {
        quoteDropdownData: []
    },
    docTypes: [],
    driverDetails: [],
    internalStatus: [],
    internalTeam: [],
    internalHistory: [],
    internalHistoryLoading: false,
    transferMode: [],
    url: '',
    teamFilter: '',
    isRebookingLoading: false,
    rebookingData: []
};

const slice = createSlice({
    name: 'bookingDetails',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        setData(state, action) {
            state.data = action.payload;
        },

        setDocTypesList(state, action) {
            state.docTypes = action.payload;
        },

        setFilters(state, action) {
            state.filters = action.payload || {};
        },

        setIsLoading(state, action) {
            const { loadingField = '', isLoading = false } = action.payload || {};
            state[loadingField] = isLoading;
        },

        setDriverDetails(state, action) {
            const { drivers, index, type } = action.payload || {};
            return {
                ...state,
                driverDetails: {
                    ...(state.driverDetails || {}),
                    [type]: {
                        ...(state.driverDetails?.[type] || {}),
                        [index]: drivers
                    }
                }
            };
        },

        setFlightData(state, action) {
            state.bookingData = action.payload || {};
        },

        setHotelsData(state, action) {
            state.bookingData = action.payload || {};
        },

        setPackageData(state, action) {
            state.bookingData = action.payload || {};
        },

        setDayWiseData(state, action) {
            state.dayWiseData = action.payload || {};
        },

        setInternalStatus(state, action) {
            state.internalStatus = action.payload || {};
        },

        setDocumentVoucher(state, action) {
            state.documentVoucher = action.payload || {};
        },
        setDocumentVoucherId(state, action) {
            state.documentVoucherId = action.payload || {};
        },

        setServiceData(state, action) {
            const { count = 0, next = null, results = {}, page = 0 } = action.payload || {};
            const { utilities = {}, service_request_list: serviceRequestList = [] } = results || {};

            state.serviceRequest.count = count;
            state.serviceRequest.next = next;
            state.serviceRequest = utilities;
            state.serviceRequest.serviceRequestList = serviceRequestList;
            state.serviceRequest.currentPage = page;
        },

        setSelectedBookingRequest(state, action) {
            state.selectedBookingRequest = action.payload;
        },

        setScheduleCollectionData(state, action) {
            state.financialData.scheduleCollection = action.payload;
        },

        setSchedulePaymentData(state, action) {
            state.financialData.schedulePayment = action.payload;
        },

        setApprovedDiscountData(state, action) {
            state.data.approvedDiscount = action.payload;
        },

        setSellerCostComponent(state, action) {
            state.data.sellerCostComponent = action.payload;
        },

        setQuoteAutosuggestData(state, action) {
            // const { response = [] } = action.payload;

            const autosuggestDropdownData = action.payload.map((item, index) => {
                const { code = '', id = '', member_list: memberList = {}, departure_at: departureAt = '' } = item || {};
                // return { code, id, label: `#${id} - ${code} - ${memberList?.title} on ${departureAt}` };
                return { id, code };
            });

            state.autoSuggestData.quoteDropdownData = autosuggestDropdownData;
        },

        setUrlLinks(state, action) {
            const { urlData = {}, fieldName = '' } = action.payload;
            const { get_cdn_file_url: url = '' } = urlData;
            // const keyName = state.data?.[fieldName];
            // if (keyName) {
            //     state.data = { ...state.data, fieldName: [...state.data?.[fieldName], url] };
            // } else {
            //     state.data = { ...state.data, fieldName: [url] };
            // }
            state.url = url;
        },
        setInternalTeam(state, action) {
            const teamsArrMapper = (action?.payload || [])?.map((item) => ({
                label: item?.name,
                value: item?.id
            }));
            return {
                ...state,
                internalTeam: teamsArrMapper
            };
        },
        setRemarksInternalHistory(state, action) {
            state.internalHistory = action.payload;
        },
        setTeamFilter(state, action) {
            state.teamFilter = action.payload;
        },
        setInternalHistoryLoading(state, action) {
            state.internalHistoryLoading = action.payload;
        },

        setPushToOnTrip(state, action) {
            state.bookingData.send_booking_to_on_trip = action.payload;
        },
        setCurrentPackageSightSeeingData(state, action) {
            if (checkIsValidArray(action.payload)) {
                state.bookingData.itinerary.sightseeings = action.payload;
            }
        },
        setTransferMode(state, action) {
            state.transferMode = action.payload;
        },
        setRebookingData(state, action) {
            state.rebookingData = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;
export const { setTeamFilter, setCurrentPackageSightSeeingData } = slice.actions;

export function getTransferMode(destinationCode = '') {
    return async () => {
        try {
            const data = await fetchTransferModes(destinationCode);
            dispatch(slice.actions.setTransferMode(data));
        } catch (error) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Error while fetching transfer modes',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getBookingDetails(bookingCode = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingDetailLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/?booking_code=${bookingCode}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setData({ ...response.data }));
            dispatch(slice.actions.hasError({}));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingDetailLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );

            dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingDetailLoading', isLoading: false }));
        }
    };
}

export function getDriversData(memberCode, index, type = 'sightSeeing') {
    const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/on-trip/supplier/?member_code=${memberCode}`;

    return async () => {
        try {
            const apiResponse = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = apiResponse || {};
            const { drivers = [] } = data || {};
            dispatch(slice.actions.setDriverDetails({ drivers, index, type }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getDocTypes() {
    // dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingDetailLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/documents/document-types`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            // dispatch(slice.actions.setData({ ...response.data }));
            // dispatch(slice.actions.hasError({}));
            response.data?.forEach((item) => {
                item.label = item.name;
            });
            dispatch(slice.actions.setDocTypesList([...response.data]));
            // dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingDetailLoading', isLoading: false }));
        } catch (error) {
            // dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );

            // dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingDetailLoading', isLoading: false }));
        }
    };
}

export function getQuoteAutosuggestData(reqCode = '') {
    const url = `${ARYABHATTA_API_DOMAIN_V1}acm/requirements/${reqCode}/quotes?booking_summary_edit=true`;
    return async () => {
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = response || {};
            dispatch(slice.actions.setQuoteAutosuggestData(data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function patchBookingData(bookingCode = '', updatedData, snackbarText = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isFlightHotelDetailLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/?booking_code=${bookingCode}`;
        try {
            const response = await axios.patch(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `${snackbarText} Updated`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function shareVoucher(bookingCode = '', updatedData, snackbarText = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'voucherLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/booking/${bookingCode}/voucher/share`;
        try {
            const response = await axios.post(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            // const { responseVoucher = {} } = response.data;
            // const { document_url: documentVoucher = '' } = responseVoucher || {};
            // dispatch(slice.actions.setDocumentVoucher(documentVoucher));
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `Voucher Shared`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'voucherLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'voucherLoading', isLoading: false }));
        }
    };
}

export function getInternalStatus() {
    dispatch(slice.actions.setIsLoading({ loadingField: 'internalStatusLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/bookings/booking-statuses`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const { results = [] } = response?.data || {};
            results?.forEach((item) => {
                item.name = item?.label;
            });
            dispatch(slice.actions.setInternalStatus([...results]));
            dispatch(slice.actions.setIsLoading({ loadingField: 'internalStatusLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            // dispatch(
            //     openSnackbar({
            //         open: true,
            //         message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
            //         variant: 'alert',
            //         alert: {
            //             color: 'error'
            //         },
            //         close: false
            //     })
            // );
            dispatch(slice.actions.setIsLoading({ loadingField: 'internalStatusLoading', isLoading: false }));
        }
    };
}

export function patchTravellerDocumentUpdate(bookingCode = '', updatedData = {}, snackbarText = '', travellerCode = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/traveller-collections/${travellerCode}/`;
        try {
            const response = await axios.patch(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `${snackbarText}`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            window.location.reload();
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function removeTraveller(
    bookingCode = '',
    updatedData = {},
    snackbarText = '',
    travellerCode = '',
    formik = {},
    indexToBeDeleted = null,
    setIndexToBeDeleted = () => {},
    setShowConfirmationModal = () => {}
) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/traveller-collections/${travellerCode}/`;
        try {
            const response = await axios.patch(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `${snackbarText}`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            formik.setFieldValue(`otherPax[${indexToBeDeleted}].is_active`, false);
            setIndexToBeDeleted(null);
            setShowConfirmationModal(false);
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function patchBookingDetailsFormData(bookingCode = '', updatedData, snackbarText = '', type = '') {
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/${type}/`;
        if (type === 'approved-discount') url += `?id=${updatedData?.id}`;
        try {
            const response = await axios.patch(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `${snackbarText} Updated`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function postBookingDetailsData(bookingCode = '', updatedData, snackbarText = '', type = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/${type}/`;
        try {
            const response = await axios.post(url, updatedData, {
                headers: {
                    source: 'mweb',
                    'Content-Type': 'multipart/form-data'
                }
            });
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function postPushToFms(providerBookingId = '', provider, bmsBookingCode = '', processVoucher = '') {
    return async () => {
        const url = `${FLIGHT_PUSH_BOOKING}api/v2/flights/booking/push-booking-details/`;
        try {
            await axios.post(
                url,
                {
                    providerBookingId,
                    provider,
                    bmsBookingCode,
                    processVoucher
                },
                {
                    headers: {
                        source: 'mweb',
                        'Content-Type': 'application/json'
                    }
                }
            );
            await dispatch(
                openSnackbar({
                    open: true,
                    message: 'Details pushed successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getFlightHotelDetail(filterType = '', type = '', bookingCategory = '', isPackageBooking = false) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isFlightHotelDetailLoading', isLoading: true }));
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/`;
        if (filterType) {
            const filterQueryString = returnFiltersQueryString(filterType);
            if (filterQueryString) {
                url = `${url}?${filterQueryString}`;
            }
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            if (type === BOOKING_TYPE) {
                if (isPackageBooking) {
                    const tripSatisFactionRating = getOnTripSatisFactionRatingFromScore(response?.data || {});
                    dispatch(slice.actions.setPackageData({ ...response?.data, tripSatisFactionRating }));
                } else if (bookingCategory === CATEGORY_FLIGHTS) {
                    const { booking_details: bookingDetails = {} } = response?.data || {};
                    dispatch(slice.actions.setFlightData({ ...bookingDetails }));
                } else if (bookingCategory === CATEGORY_ACCOMODATION) {
                    const { results = {} } = response?.data || {};
                    dispatch(slice.actions.setHotelsData({ ...results }));
                }
            }
            dispatch(slice.actions.setIsLoading({ loadingField: 'isFlightHotelDetailLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            if (bookingCategory === CATEGORY_FLIGHTS) {
                dispatch(slice.actions.setFlightData({ ...error }));
            } else if (bookingCategory === CATEGORY_ACCOMODATION) {
                dispatch(slice.actions.setHotelsData({ ...error }));
            } else if (bookingCategory === CATEGORY_PACKAGES) {
                dispatch(slice.actions.setPackageData({ ...error }));
            }

            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isFlightHotelDetailLoading', isLoading: false }));
        }
    };
}

export function patchBookingDetailsData(
    bookingCode = '',
    updatedData,
    snackbarText = '',
    type = '',
    setBookingStatus,
    filters = null,
    resetForm = () => {}
) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isEditBookingLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/${type}/`;
        try {
            await axios.patch(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `${snackbarText} Updated`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            if (filters) {
                await dispatch(getFlightHotelDetail(filters, BOOKING_TYPE, CATEGORY_PACKAGES, true));
            }
            dispatch(slice.actions.setIsLoading({ loadingField: 'isEditBookingLoading', isLoading: false }));
            resetForm();
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isEditBookingLoading', isLoading: false }));
        }
    };
}

export function getVoucher(bookingCode = '', updatedData, filters) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'voucherLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/booking/${bookingCode}/voucher/generate`;
        try {
            const response = await axios.post(url, updatedData);
            const { response: responseVoucher = {} } = response.data;
            const { document_url: documentVoucher = '', id: voucherID = null } = responseVoucher || {};
            dispatch(slice.actions.setDocumentVoucher(documentVoucher));
            dispatch(slice.actions.setDocumentVoucherId(voucherID));
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `Voucher Generated`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'voucherLoading', isLoading: false }));
            await dispatch(getFlightHotelDetail(filters, BOOKING_TYPE, CATEGORY_PACKAGES, true));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'voucherLoading', isLoading: false }));
        }
    };
}

export function getDayWiseItinerary({ itineraryId = '' }) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/itinerary/${itineraryId}/day-wise-itinerary`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = response || {};
            const { response: dataResponse = {} } = data || {};
            const { error_responses: err = [] } = dataResponse || {};
            if (err && err?.length !== 0) {
                const { error = '' } = err?.[0] || {};
                dispatch(
                    openSnackbar({
                        open: true,
                        message: error || DEFAULT_ERROR_MESSAGE,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: false
                    })
                );
            } else {
                dispatch(slice.actions.setDayWiseData({ ...response?.data }));
            }
            // window.location.reload();
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function editPackageDetailsFormData({
    bookingCode = '',
    updatedData = {},
    snackbarText = '',
    itineraryId = '',
    isRouteChange = false,
    arrayHelpers = () => {},
    index = 0,
    filters = {},
    handleRemove = () => {},
    updateUsingAPI = true
}) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/customize-itinerary/${itineraryId}`;
        let hasErr = false;
        try {
            const response = await axios.post(url, updatedData, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = response || {};
            const { response: dataResponse = {} } = data || {};
            const { error_responses: err = [] } = dataResponse || {};
            if (err && err?.length !== 0) {
                const { error = '' } = err?.[0] || {};
                hasErr = true;
                dispatch(
                    openSnackbar({
                        open: true,
                        message: error || DEFAULT_ERROR_MESSAGE,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: false
                    })
                );
            } else {
                await dispatch(
                    openSnackbar({
                        open: true,
                        message: snackbarText,
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: false
                    })
                );
                if (isRouteChange) {
                    arrayHelpers.remove(index);
                }
            }
            if (updateUsingAPI) {
                await dispatch(getFlightHotelDetail(filters, BOOKING_TYPE, CATEGORY_PACKAGES, true));
            }
            await dispatch(getDayWiseItinerary({ itineraryId }));
            await handleRemove();
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            hasErr = true;
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
        return { hasErr };
    };
}

export function sendMailToSupplier({ bookingCode = '', postBody = {} }) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/send-pbo-mail/`;
        try {
            const response = await axios.post(url, postBody, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = response || {};
            const { response: dataResponse = {} } = data || {};
            const { error_responses: err = [] } = dataResponse || {};
            if (err && err?.length !== 0) {
                const { error = '' } = err?.[0] || {};
                dispatch(
                    openSnackbar({
                        open: true,
                        message: error || DEFAULT_ERROR_MESSAGE,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: false
                    })
                );
            } else {
                await dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Mail Sent!',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: false
                    })
                );
            }
            // window.location.reload();
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function sendMailToAgent({ bookingCode = '', postBody = {} }) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/send-pbo-mail/`;
        try {
            const response = await axios.post(url, postBody, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = response || {};
            const { response: dataResponse = {} } = data || {};
            const { error_responses: err = [] } = dataResponse || {};
            if (err && err?.length !== 0) {
                const { error = '' } = err?.[0] || {};
                dispatch(
                    openSnackbar({
                        open: true,
                        message: error || DEFAULT_ERROR_MESSAGE,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: false
                    })
                );
            } else {
                await dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Mail Sent!',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: false
                    })
                );
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function postBookingDetailsFormData(bookingCode = '', updatedData, snackbarText = '', type = '') {
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/${type}`;
        if (!(snackbarText === 'Scheduled Collection' || snackbarText === 'Scheduled Payment')) url += '/';
        try {
            const response = await axios.post(url, updatedData, {
                headers: {
                    source: 'mweb'
                    // 'Content-Type': 'multipart/form-data'
                }
            });
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function postDownloadAllDocs(body = {}) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/documents/download-all`;
        try {
            const response = await axios.post(url, body, {
                headers: {
                    source: 'mweb'
                    // 'Content-Type': 'multipart/form-data'
                }
            });
            const { response: responseData = {} } = response?.data;
            const { url: resUrl = '' } = responseData || {};
            window.open(resUrl);
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getBookingRequestsData(pageChangeUrl = '', filterType = '', newPage = 0) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingRequestLoading', isLoading: true }));
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}bms/service-requests/`;
        if (pageChangeUrl) {
            url = pageChangeUrl;
        }
        if (filterType) {
            const filterQueryString = returnFiltersQueryString(filterType);
            if (pageChangeUrl && filterQueryString) {
                url = `${url}&${filterQueryString}`;
            } else if (filterQueryString) {
                url = `${url}?${filterQueryString}`;
            }
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setServiceData({ ...response.data, page: newPage }));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingRequestLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingRequestLoading', isLoading: false }));
        }
    };
}

export function getSelectedBookingRequest(serviceRequestCode = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/service-requests/?booking_code=${serviceRequestCode}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const { results = {} } = response?.data || {};
            const { service_request_list: serviceRequestList = [] } = results || [];
            dispatch(slice.actions.setSelectedBookingRequest({ ...serviceRequestList[0] }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getScheduledCollection(bookingCode = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isScheduleCollectionLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/planned-payments/?type=due_on_member`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setScheduleCollectionData([...response.data]));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isScheduleCollectionLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isScheduleCollectionLoading', isLoading: false }));
        }
    };
}

export function getScheduledPayment(bookingCode = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isSchedulePaymentLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/planned-payments/?type=due_to_member`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setSchedulePaymentData([...response.data]));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isSchedulePaymentLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isSchedulePaymentLoading', isLoading: false }));
        }
    };
}

export function getApprovedDiscount(bookingCode = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isApprovedDiscountLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/approved-discount/`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setApprovedDiscountData({ ...response.data }));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isApprovedDiscountLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isApprovedDiscountLoading', isLoading: false }));
        }
    };
}

export function getSellerCostComponent(bookingCode = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isSellerCostLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/seller-cost-component/`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setSellerCostComponent({ ...response.data }));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isSellerCostLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isSellerCostLoading', isLoading: false }));
        }
    };
}

export function uploadNewPboDoc(
    bookingCode = '',
    travellerCode = '',
    body = {},
    isMultipart = false,
    handleClose = () => {},
    bookingDetailsData = {},
    updateItinerary = () => {},
    snackbarMsg = ''
) {
    const formData = new FormData();
    if (isMultipart) {
        Object.values(body)?.forEach((item, idx) => {
            const key = Object.keys(body)?.[idx];
            formData.append(key, item);
        });
    }
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}bms/bookings/${bookingCode}/traveller-collections/${travellerCode}/`;
        try {
            const response = await axios.patch(url, isMultipart ? formData : body, {
                headers: {
                    source: 'web'
                }
            });
            await dispatch(
                openSnackbar({
                    open: true,
                    message: snackbarMsg || 'Documents added.',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            handleClose();
            updateItinerary(bookingDetailsData, bookingCode);
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function postFileGetUrl(file, linkFieldName = '', formik = {}, index = 0, setFileUrl = () => {}) {
    const formData = new FormData();
    formData.append('file', file);
    return async () => {
        const url = `${DOCS_API_DOMAIN}docs/api/v2/upload`;
        try {
            const response = await axios.post(url, formData, {
                headers: {
                    source: 'mweb',
                    'Content-Type': 'multipart/form-data'
                }
            });
            const { get_cdn_file_url: fileUrl = '' } = response.data;
            // if (index !== null) formik.setFieldValue(`${index}.${linkFieldName}`, fileUrl);
            await formik.setFieldValue(linkFieldName, fileUrl);
            setFileUrl(fileUrl);
            // dispatch(slice.actions.setUrlLinks({ urlData: { ...response.data }, linkFieldName }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function pushToOntrip(bookingCode = '', updatedData, snackbarText = '', isPushedToOntrip = false, setIsPushedToOntrip = () => {}) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/on-trip/${bookingCode}/push-booking/`;
        try {
            const response = await axios.post(url, updatedData, {
                headers: {
                    source: 'website',
                    'Content-Type': 'application/json'
                }
            });
            dispatch(
                openSnackbar({
                    open: true,
                    message: snackbarText,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );

            dispatch(slice.actions.setPushToOnTrip(isPushedToOntrip));

            // await dispatch(getFlightHotelDetail(filters, BOOKING_TYPE, CATEGORY_PACKAGES, true));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            setIsPushedToOntrip(!isPushedToOntrip);
        }
    };
}

export const getTeams = () => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}${HOLIDAY}/${HOLIDAYS_SYSYTEM}/internal-teams`;
    return async () => {
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = response;
            const { results = [] } = data;

            dispatch(slice.actions.setInternalTeam(results));
        } catch (error) {
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
};

export const getInternalHistory = (bookingCode = '') => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}${HOLIDAY}/${BOOKINGS}/${bookingCode}/internal-history`;
    return async () => {
        try {
            dispatch(slice.actions.setInternalHistoryLoading(true));
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const { data = {} } = response;
            dispatch(slice.actions.setRemarksInternalHistory(data));
        } catch (error) {
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        } finally {
            dispatch(slice.actions.setInternalHistoryLoading(false));
        }
    };
};

export const setLoadingState =
    (isLoading = false) =>
    () => {
        dispatch(slice.actions.setIsLoading(isLoading));
    };

export const filterRequestData =
    (filter = '') =>
    async () => {
        dispatch(slice.actions.setFilters(filter));
    };

export const clearDriversList = () => {
    dispatch(slice.actions.setDriverDetails([]));
};

export const getRebookingLogs = (bookingCode, memberCode) => async () => {
    try {
        dispatch(slice.actions.setIsLoading({ loadingField: 'isRebookingLoading', isLoading: true }));
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/rebooking/?booking_code=${bookingCode}&buyer=${memberCode}`;
        const {
            data: { results = [] }
        } = await axios.get(url, {
            headers: {
                source: 'mweb'
            }
        });
        dispatch(slice.actions.setRebookingData(results));
    } catch (error) {
        dispatch(slice.actions.hasError(error));
        const { error: errorObj = {}, detail = '' } = error || {};
        const { errorMessage = '' } = errorObj || {};
        dispatch(
            openSnackbar({
                open: true,
                message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false
            })
        );
    } finally {
        dispatch(slice.actions.setIsLoading({ loadingField: 'isRebookingLoading', isLoading: false }));
    }
};
